import { render, staticRenderFns } from "./MedicalCenterPage.vue?vue&type=template&id=72f33a20&"
import script from "./MedicalCenterPage.vue?vue&type=script&lang=js&"
export * from "./MedicalCenterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports